/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class FaultApi {
    static getInstance() {
        if (!this.instance) this.instance = new FaultApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取故障整车比例
    async getFaultRate (){
        let url = `/api/sys/fault/rate`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取故障码上报比例
    // async getFaultCodeRate (param){
    //     let url = `/api/sys/fault/code/rate`
    //     let result = await this.getData(url,param,'GET')
    //     return result
    // }

    // 获取故障部件占比
    async getFaultPartRate (param){
        let url = `/api/sys/fault/part/rate`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取故障码列表
    async getFaultCodeList (param,page_num,page_size){
        let url = `/api/sys/fault/code/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增故障码
    async addFaultCode (param){
        let url = `/api/sys/fault/code`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 编辑故障码
    async editFaultCode (id,param){
        let url = `/api/sys/fault/code/${id}`
        let result = await this.getData(url,param,'PATCH')
        return result
    }

    // 删除故障码
    async delFaultCode (id){
        let url = `/api/sys/fault/code/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 故障码新增编辑-上传图片
    async uploadPictures (param){
        let url = `/api/sys/pictures/upload`
        let result = await this.getData(url,param,'POST','multipart/form-data')
        return result
    }

    // 获取故障整车比例
    async getFaultRate (param){
        let url = `/api/sys/fault/item/rate`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取故障码上报比例
    async getFaultCodeRate (param){
        let url = `/api/sys/fault/item/code/rate`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 查询故障明细列表
    async getFaultDetail (param,page_num,page_size){
        let url = `/api/sys/fault/item/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 整车故障率 
    async getFaultRideRate (param){
        let url = `/api/sys/fault/ride/rate`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 查询故障代码 
    // async getFaultCode (param,page_num,page_size){
    //     let url = `/api/sys/fault/mapping/query`
    //     let result = await this.getData(url,param,'POST')
    //     return result
    // }

    // // 整车故障率 
    // async getFaultItemRate (param){
    //     let url = `/api/sys/fault/item/rate`
    //     let result = await this.getData(url,param,'GET')
    //     return result
    // }

    // // 整车故障率 
    // async getFaultItemCodeRate (param){
    //     let url = `/api/sys/fault/item/code/rate`
    //     let result = await this.getData(url,param,'GET')
    //     return result
    // }


    // 获取故障码列表
    async getFaultCodeList (param,page_num,page_size){
        let url = `/api/sys/fault/code/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增故障码
    async addFaultCode (param){
        let url = `/api/sys/fault/code`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 编辑故障码
    async editFaultCode (id,param){
        let url = `/api/sys/fault/code/${id}`
        let result = await this.getData(url,param,'PATCH')
        return result
    }

    // 删除故障码
    async delFaultCode (id){
        let url = `/api/sys/fault/code/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 故障码新增编辑-上传图片
    async uploadPictures (param){
        let url = `/api/sys/pictures/upload`
        let result = await this.getData(url,param,'POST','multipart/form-data')
        return result
    }

}

export {
    FaultApi
}